<template>
  <v-app id="compare-page">
    <Menu />
    <v-container grid-list-lg id="products">
      <v-layout row wrap v-if="products">
      
        <v-flex xs12 sm4 md4 v-for="(item, index) in products" :key="index">
       
          <v-card class="mt-2 product-compare-card" >
            <v-layout row wrap>
   <v-btn icon id="closeBtn" color="primary" @click="deleteProduct(index)">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
              <!-- Product naam -->
              <v-flex xs12>
                <span class="compare-product-title font-weight-strong">Product #{{index + 1}}</span>
                <br>
                <p class="font-weight-light"> {{item.naam}}</p>
              </v-flex>


              <!-- Product item -->
              <v-flex xs12 v-if="item.product">
                <span class="item-title"><strong>Type Stof</strong></span> <br>
                <span class="item-product">{{item.product}}</span>
              </v-flex>


              <!-- Prijs van stof -->
              <v-flex xs12 v-if="item.stofprijs">
                <span class="item-title"><strong>Prijs van de stof:</strong></span> <br>
                <span class="item-product">&#8364; {{item.stofprijs}}</span>
              </v-flex>

              <!-- Afmetingen -->
              <v-flex xs12 v-if="item.breedte && item.hoogte">
                <span class="item-title"><strong>Afmetingen:</strong></span> <br>
                <span class="item-product">Breedte {{item.breedte}}mm x</span><span class="item-product"> Hoogte
                  {{item.hoogte}}mm</span>
              </v-flex>

              <v-flex xs12 v-if="item.plooi">
                <span class="item-title"><strong>Plooi:</strong></span> <br>
                <span class="item-product">{{item.plooi}}</span>
              </v-flex>

              <v-flex xs12 v-if="item.ruimte" class="text-truncate">
                <span class="item-title"><strong>Ruimte:</strong></span> <br>
                <span class="item-product">{{item.ruimte}}</span>
              </v-flex>
            </v-layout>
            <!-- <hr class="seperator-line"> -->
            <v-layout row wrap mb-2 mt-4 class="footer-card">
              <v-flex xs12>
                <hr class="seperator-line"> 
              </v-flex>
              <v-flex xs6 sm2 md2>
                <span class="total-title">
                  Totaal
                </span>
              </v-flex>
              <v-flex xs6 sm10 md10 text-xs-right>
                <span class="product-price-title ml-4">Prijs compleet, incl. BTW</span> &nbsp;
                <span class="product-price">&#8364; {{item.totaleprijs | currency}}</span>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- Open Modal Button -->
      <v-flex mt-5 xs12>
        <v-btn depressed color="primary" @click="showModal" class="text-none modal-btn">Maak een richtprijs
          <v-icon right>fal fa-paper-plane</v-icon>
        </v-btn>
        <Form v-show="dialog" @close="closeModal" @sendMail="submitProducts" />
      </v-flex>
    </v-container>
    
    <SnackBar v-model="snackbar" :text="messageTxt" :color="color" />
  </v-app>

</template>

<script>
import Form from '@/components/DialogForm.vue'; // Modal Component
import Menu from '@/components/Menu' // Menu Component 
import FormatService from '@/services/format.service'; // Filters
import ApiService from '@/services/api.service'; // Api
import SnackBar from '@/components/SnackBar'; // MessagesContainer
import Messages from '@/services/messages.service'; // Messages
import { mapState } from 'vuex';

export default {
  data() {
    return {
      dialog: false,
      // products: [],
      snackbar: false,
      color: '',
      messageTxt: ''
    }
  },
  created(){
  if(this.cartCount == 0){
        this.$router.push({name: 'Producten'})
    }
  },
  updated() {
    if(this.cartCount == 0){
        this.$router.push({name: 'Producten'})
    }
  },
  computed: {
    ...mapState('products', ['products', 'cartCount'])
  },
  methods: {
    showModal() {
      this.dialog = true;
    },
    closeModal() {
      this.dialog = false;
    },
    submitProducts(value){
      console.log(this.products)
      let products = JSON.parse(JSON.stringify(this.products))

      products = products.map(el => {
        if(el.totaleprijs) {
            el.totaleprijs = `€ ${el.totaleprijs.toFixed(2)}`
        }
        return el;
      })

      console.log(products)



       ApiService.sendEmail({
        producten: products,
        info: value
      }).then(() => {
            this.dialog = false;
      this.snackbar = true;
      this.messageTxt = Messages.EmailSendMessage;
      this.color = 'success'
      
      })
    },
    deleteProduct(index){
      this.$store.dispatch('products/removeProduct', index)
    }
  },
  components: {
    Form,
    Menu,
    SnackBar
  },
  filters: {
      ...FormatService
  }
}
</script>



<style scoped>
#compare-page {
    background-color: #fff;
}

.product-compare-card {
    box-shadow: unset !important;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-top: 3px solid #006fb3;
    padding: 1em;
    height: 450px;
}

.footer-card {
  position: absolute;
  bottom: 0;
  right: 5px;
  left: 5px;
}

/* @media screen and (max-width: 768px){
  .footer-card {
    left: 0;
  }
} */

.item-title {
    color: #707070;
    font-size: 11px;
    /* font-weight: 700; */
}

.item-product {
    color: #707070;
    font-size: 11px;
    font-weight: 400;
}

.seperator-line {
    border: 1px solid #b4b4b4;
    margin: 0 auto;
}

.product-price-title {
    font-weight: 400;
    color: #006fb3;
    font-size: 10px;
    
}

.product-price {
    font-weight: 700;
    font-size: 13px;
    color: #006fb3;
}

.compare-product-title {
    color: #000000;
    font-size: 15px;
    font-weight: 700;
}


.modal-btn {
    float: right;
    height: 60px;
    border-radius: 4px;
}

.total-title {
    color: #006fb3;
    font-size: 15px;
    font-weight: 400;
}

@media screen and (max-width: 1024px) {
    .product-compare-card {

        width: 100%;
    }
}

#closeBtn {
  position: absolute;
  z-index: 0;
  right: 0;
}
</style>
